'use client'
import { useState } from 'react'
import { glossaryOf, type TermLang } from '@/lib/glossary'
import { useAppStore } from '@/store/app'

export default function TermTip({ term, className }: { term: string; className?: string }) {
  const lang = useAppStore((s) => s.language) as TermLang
  const def = glossaryOf(term)
  const [open, setOpen] = useState(false)
  if (!def) return null
  const d = def[lang] ?? def['en']
  return (
    <span
      className={`relative inline-flex items-center ${className ?? ''}`}
      style={{ verticalAlign: 'middle', position: 'relative' }}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      onClick={(e) => {
        e.stopPropagation()
        setOpen((v) => !v)
      }}
    >
      <span
        role="button"
        tabIndex={0}
        aria-label={d.term}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 16,
          height: 16,
          borderRadius: 8,
          fontSize: 11,
          lineHeight: 1,
          cursor: 'help',
          color: '#fff',
          background: 'rgba(120,130,160,0.55)',
          marginLeft: 3,
          userSelect: 'none',
        }}
      >
        i
      </span>
      {open && (
        <span
          role="tooltip"
          style={{
            position: 'absolute',
            left: 0,
            top: 'calc(100% + 4px)',
            zIndex: 9999,
            minWidth: 320,
        maxWidth: 520,
            padding: '8px 10px',
            borderRadius: 8,
            fontSize: 12,
            lineHeight: 1.5,
            color: '#fff',
            background: '#1e2430',
            boxShadow: '0 4px 16px rgba(0,0,0,0.35)',
            border: '1px solid rgba(255,255,255,0.12)',
            whiteSpace: 'normal',
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: 6,
            wordBreak: 'break-word',
          }}
        >
          <strong style={{ display: 'inline', marginRight: 4 }}>{d.term}</strong>
          {d.short}
        </span>
      )}
    </span>
  )
}
